import PipelineInboxesAPI from 'dashboard/api/pipelines/pipelineInboxes';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getInboxes: _state => _state.records,
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  get: async ({ commit }, { accountId, pipelineId }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await PipelineInboxesAPI.get(accountId, pipelineId);
      commit('SET_INBOXES', response.data.payload);
      return response;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  update: async ({ commit }, { accountId, pipelineId, inboxIds }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await PipelineInboxesAPI.update(accountId, pipelineId, inboxIds);
      return response;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
};

export const mutations = {
  SET_INBOXES(_state, inboxes) {
    _state.records = inboxes;
  },

  SET_UI_FLAG(_state, flag) {
    _state.uiFlags = { ..._state.uiFlags, ...flag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
